module.exports = new __parcel__URL__("AttachmentIllustration.0cb53b6e.svg").toString();